<template>
  <action-person-template :action="action" column="person2" grid="person2" title="Joueur sortant"/>
</template>

<script>
import ActionPersonTemplate from './ActionPersonTemplate'

export default {
  name: 'SportFootballMatchActionPersonSubstitued',
  props: {
    action: Object
  },
  components: { ActionPersonTemplate }
}
</script>
